export default "/_next/static/fonts/IntercomBrush-Small-0bbf0a388644b884be00f56fc9e225de.woff2";